import { render } from "./ScheduleBuilder.vue?vue&type=template&id=2c94dd60&scoped=true"
import script from "./ScheduleBuilder.vue?vue&type=script&lang=ts"
export * from "./ScheduleBuilder.vue?vue&type=script&lang=ts"

import "./ScheduleBuilder.vue?vue&type=style&index=0&id=2c94dd60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c94dd60"

export default script